import { render } from "./SwitchButton.vue?vue&type=template&id=5db23211&scoped=true"
import script from "./SwitchButton.vue?vue&type=script&lang=js"
export * from "./SwitchButton.vue?vue&type=script&lang=js"

import "./SwitchButton.vue?vue&type=style&index=0&id=5db23211&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db23211"]])

export default __exports__